// extracted by mini-css-extract-plugin
export default {"box":"fallback_box__VCw9w","loader":"fallback_loader__Cyv26"};